import { isWithinCutWindow } from './is-within-cut-window';

type TEnrichmentTimeRange = {
  s_datetime?: Date;
  start_datetime?: string;
};

/**
 * Statements, logos and people are all judged by the instant they start at: the
 * same instant the add gate checked, and the one reports and the review seek jump
 * to. Presences also carry an end, but a range straddling a cut bound still
 * covers the cut, so widening it here would accuse correct presences.
 *
 * A cut without both bounds encloses nothing yet, and an enrichment with no
 * instant cannot be placed, so both answer "inside": this drives a red mark in
 * front of the reviewer and must never accuse what it cannot judge.
 */
function isEnrichmentOutsideCut(
  enrichment: TEnrichmentTimeRange,
  cutStart: Date | null,
  cutEnd: Date | null
): boolean {
  if (!cutStart || !cutEnd) return false;

  const datetime = enrichment.s_datetime || enrichment.start_datetime;
  if (!datetime) return false;

  return !isWithinCutWindow(new Date(datetime), cutStart, cutEnd);
}

export { isEnrichmentOutsideCut };
export type { TEnrichmentTimeRange };
